import * as Api from '@ViewModels';
import produce from 'immer';
import { useCallback, useMemo } from 'react';

export const useJobTitleFilter = ({
	filter,
	onChangeFilter,
}: {
	filter: Api.IBulkContactsRequest;
	onChangeFilter: (filter: Api.IBulkContactsRequest) => void;
}) => {
	const jobTitle = useMemo(() => {
		const criterion = filter.filter.criteria.find(c => c.property === Api.ContactFilterCriteriaProperty.JobTitle);
		return criterion?.value ?? '';
	}, [filter.filter.criteria]);

	const setJobTitle = useCallback(
		(value: string) => {
			const nextFilter = produce(filter, draftFilter => {
				const existingIndex = draftFilter.filter.criteria.findIndex(
					c => c.property === Api.ContactFilterCriteriaProperty.JobTitle
				);

				if (value.trim() === '') {
					if (existingIndex > -1) {
						draftFilter.filter.criteria.splice(existingIndex, 1);
					}
					return;
				}

				const newCriterion: Api.IContactFilterCriteria = {
					property: Api.ContactFilterCriteriaProperty.JobTitle,
					value: value.trim(),
				};

				if (existingIndex > -1) {
					draftFilter.filter.criteria[existingIndex] = newCriterion;
				} else {
					draftFilter.filter.criteria.push(newCriterion);
				}
			});

			onChangeFilter(nextFilter);
		},
		[filter, onChangeFilter]
	);

	const clearJobTitleFilter = useCallback(() => {
		const nextFilter = produce(filter, draftFilter => {
			draftFilter.filter.criteria = draftFilter.filter.criteria.filter(
				c => c.property !== Api.ContactFilterCriteriaProperty.JobTitle
			);
		});

		onChangeFilter(nextFilter);
	}, [filter, onChangeFilter]);

	const hasJobTitleFilter = jobTitle !== '';

	return {
		jobTitle,
		setJobTitle,
		clearJobTitleFilter,
		hasJobTitleFilter,
	};
};
